import { SvgIconProps } from "@mui/material/SvgIcon";

interface BoldIconProps extends SvgIconProps {
  strokeWidth?: number;
}

const UnderlineIcon: React.FC<BoldIconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width={props.strokeWidth || 1.5}
      stroke-linecap="round"
      stroke-linejoin="round"
      className="lucide lucide-underline-icon lucide-underline"
    >
      <path d="M6 4v6a6 6 0 0 0 12 0V4" />
      <line x1="4" x2="20" y1="20" y2="20" />
    </svg>
  );
};

export default UnderlineIcon;
